const AREA = 'area'
const AUTH_TOKEN = "x-auth-token"
const AUTH_USER = "x-auth-user"

export {
  AREA,
  AUTH_TOKEN,
  AUTH_USER
}